module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "gap": "4px"
    }
  }, [(typeof _vm.orders_stat.initial === 'number' || typeof _vm.orders_stat.initial === 'string') ? _c('AppTooltip', {
    attrs: {
      "bottom": "bottom",
      "maxWidth": "200px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('div', _vm._g(_vm._b({
          staticClass: "d-flex"
        }, 'div', attrs, false), on), [_c('AppSvgIcon', {
          staticClass: "ui_color__green-successful me-1",
          attrs: {
            "template": _vm.$ui.IconSvgComponents.roundedPlus,
            "colorMode": "multi"
          }
        }), _c('span', [_vm._v(_vm._s(_vm.orders_stat.initial))])], 1)]
      }
    }], null, false, 316178582)
  }, [_c('div', {
    staticClass: "ui_color__white"
  }, [_vm._v("Новые заявки")])]) : _vm._e(), (typeof _vm.orders_stat.approve === 'number' || typeof _vm.orders_stat.approve === 'string') ? _c('AppTooltip', {
    attrs: {
      "bottom": "bottom",
      "maxWidth": "200px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('div', _vm._g(_vm._b({
          staticClass: "d-flex"
        }, 'div', attrs, false), on), [_c('AppSvgIcon', {
          staticClass: "ui_color__green-successful me-1",
          attrs: {
            "template": _vm.$ui.IconSvgComponents.roundedCheckmark,
            "colorMode": "multi"
          }
        }), _c('span', [_vm._v(_vm._s(_vm.orders_stat.approve))])], 1)]
      }
    }], null, false, 4169414990)
  }, [_c('div', {
    staticClass: "ui_color__white"
  }, [_vm._v("Подтвержденные заявки")])]) : _vm._e(), (typeof _vm.orders_stat.study === 'number' || typeof _vm.orders_stat.study === 'string') ? _c('AppTooltip', {
    attrs: {
      "bottom": "bottom",
      "maxWidth": "200px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('div', _vm._g(_vm._b({
          staticClass: "d-flex"
        }, 'div', attrs, false), on), [_c('AppSvgIcon', {
          staticClass: "ui_color__green-successful me-1",
          attrs: {
            "template": _vm.$ui.IconSvgComponents.graduateCap,
            "colorMode": "multi"
          }
        }), _c('span', [_vm._v(_vm._s(_vm.orders_stat.study))])], 1)]
      }
    }], null, false, 2631981657)
  }, [_c('div', {
    staticClass: "ui_color__white"
  }, [_vm._v("Обучается")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6549746","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/orders-stat/OrdersStat.vue
// module id = 0eb41853cc262f725304
// module chunks = 5